// GENERATED FILE - DO NOT MODIFY

export enum DailyBookingSummaryPeriodStatusDto {
    Unknown = "Unknown",
    Available = "Available",
    Unavailable = "Unavailable",
}